import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { router } from './router';
import { queryClient } from './lib/queryClient';
import { useAuthStore } from './lib/auth-store';
import { initializeTheme } from './lib/theme';

export function App() {
  const initialize = useAuthStore((s) => s.initialize);

  useEffect(() => {
    initializeTheme();
    void initialize();
  }, [initialize]);

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
